export default {
  placeDetails: {
    layer: 'Ebene',
    lat: 'Breite',
    lon: 'Länge',
    notAvailable: 'Nicht verfügbar',
    placeDetails: 'Details zum Ort',
    placeName: 'Name',
    latlngCopied: 'Breiten- und Längengrad kopiert',
    lnglatCopied: 'Längen und Breitengrad kopiert',
    copyLatlng: 'Im Format "Breitengrad, Längengrad" kopieren',
    copyLnglat: 'Im Format "Längengrad, Breitengrad" kopieren',
    satelliteView: 'Satellitenbild'
  }
}
